<template>
  <section class="choose-theme-sec">
    <div class="container">
        <div class="inbox-empty">
    	   <img alt="commaful-logo" src="../assets/images/empty-inbox.png" />
           <h2>Don't Have Any Message</h2>
           <p>Start sending your message with your friends</p>
           <button class="newMessageBtn" @click="showMsgModals()">NEW MESSAGE</button>
        </div>
    </div>



    <!-- message modal start -->
    <modal v-if="msgModal" @close="msgModal = false" class="importText empty-msg-mdl">
        <div slot="modalFixed">
            Lorem ipsum dolor sit amet
        </div>
        <div slot="closeModal" class="x-msg-mdl-cls" @click="msgModal = false">
           <img alt="commaful-logo" src="../assets/images/x.png" />
        </div>
        <div slot="header">

            <div class="searchFriendInModal">
               <input type="test" placeholder="Find your friends" >
               <img alt="commaful-logo" src="../assets/images/Search.png" />
           </div>
           
        </div>
        <div slot="body">
          <ul class="profileModal">
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin sdfdff</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin sdfdf</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
              <li>
                  <router-link to="/single-chat/1" class="profileModalItem">
                      <div class="modalProImg">
                            <img alt="commaful-logo" src="../assets/images/f1.png" />
                      </div>
                      <div class="modalProDesc">
                            <h3>Neville Griffin</h3>
                            <p>@nevilleg</p>
                      </div>
                  </router-link>
              </li>
          </ul>
        </div>
        <div slot="footer" class="import-btn">        
       
            
           
        </div>
    </modal>
    <!-- message modal end -->

  </section>
</template>

<script>
export default {

	data() {
		return {
			msgModal:false,
		}
	},

	methods: {
		showMsgModals() {
      this.msgModal=true;
    }
	},


}

</script>



<style>
	.inbox-empty{
        min-height: 70vh;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .inbox-empty h2{
      z-index: 5;
      color: #214163;
      font-family: "Playfair Display";
      font-size: 32px;
      font-weight: 700;
      line-height: 54px;
      margin-top: 30px;
    }

    .inbox-empty p{
      color: #214163;
      font-family: Lato;
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0.4px;
    }


    .newMessageBtn {
        margin-top: 20px;
        padding: 15px 50px;
        z-index: 5;
        border-radius: 5px;
        background: #00c6c6;
        color: #ffffff;
        font-family: Lato;
        font-size: 14px;
        font-weight: 700;
        line-height: 17px;
        text-align: center;
        letter-spacing: 3px;
        border: none;
        cursor: pointer;
        outline: none;
        transition: .5s;
        margin-bottom: 30px;
    }
    .newMessageBtn:hover{
        background: #029696;
    }


    .x-msg-mdl-cls {
        box-shadow: none !important;
        opacity: .4;
        width: 15px !important;
    }

    .empty-msg-mdl .modal-container {
        border-radius: 15px;
        overflow: hidden;
        padding: 25px 10px;
    }
    .empty-msg-mdl .modal-body {
        overflow: auto;
        height: 70vh;
        position: relative;
        padding: 0px 30px;
    }

    .searchFriendInModal {
        padding-bottom: 24px;
        position: relative;
        top: 25px;
        margin: 0px 30px;
    }

    .searchFriendInModal input {
        width: 100%;
        border: solid 1px rgba(151,151,151,0.25);
        height: 50px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        color: #214163;
        font-family: Lato;
    }

    .searchFriendInModal img {
        position: absolute;
        right: 15px;
        top: 16px;
        opacity: .5;
    }


    .empty-msg-mdl ::-webkit-scrollbar {
      width: 6px;
    }

    /* Track */
     .empty-msg-mdl ::-webkit-scrollbar-track {
      /*-webkit-box-shadow: inset 0 0 1px #233049;
              box-shadow: inset 0 0 1px #233049; */
      border-radius: 5px;
      margin: 0px;
      background: #E9EAEC;
      opacity: .1
    }
     
    /* Handle */
     .empty-msg-mdl ::-webkit-scrollbar-thumb {
      background: #868D9A; 
      border-radius: 4px;
      margin: 0px;
    }

    /*------------- show profile in modal ----------------*/
    .profileModal{
        margin: 0px;
        padding: 0px;
        list-style: none;
    }
    .profileModal li {
        width: 50%;
        margin-bottom: 5px;
        display: inline-block;
        padding: 8px 5px;
        transition: .5s;
        box-sizing: border-box;
    }

    .profileModal li:hover {
        background: #00c6c6;
        box-shadow: 0px 5px 15px rgba(16,27,79,0.15);
        display: inline-block;
        border-radius: 12px;
    }
    .profileModal .profileModalItem {
        display: flex;
        align-items: center;
        padding: 0px 15px;
    }
    .modalProDesc {
        margin-left: 10px;
    }
    .modalProDesc h3 {
        margin: 0px;
        color: #214163;
        font-family: Lato;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.5px;
    }

    .modalProDesc p {
        margin: 0;
        color: #214163;
        font-family: Lato;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0.5px;
    }

    .profileModal li:hover .modalProDesc p,
    .profileModal li:hover .modalProDesc h3{
        color: #fff;
    }
    .modalProImg {
        width: 55px;
        height: 55px;
    }
    .modalProImg img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
    }

    @media only screen and (max-width: 767px){
        .empty-msg-mdl .modal-body {
            height: 65vh;
            padding: 0px 15px;
        }

        .modal-close>div img {
                width: 10px;
        }

        .modal-close>div {
            margin-top: -10px;
            margin-left: 10px;
        }
        .searchFriendInModal {
            margin: 0px 15px;
        }
        .searchFriendInModal input {
            height: 40px;
            padding: 3px 10px;
        }
        .searchFriendInModal img {
            right: 10px;
            top: 13px;
        }
        .modalProImg img,
        .modalProImg {
          width: 35px;
          height: 35px;
        }

        .modalProDesc {
            margin-left: 5px;
        }

        .modalProDesc h3 {
          font-size: 12px;
          line-height: 18px;
        }

        .modalProDesc p {
            font-size: 10px;
        }
    }



    @media only screen and (max-width: 550px){
      .profileModal li {
          padding: 12px 10px;
          width: 100%;
          margin-bottom: 0px
      }

      .modalProImg img, .modalProImg {
          width: 50px;
          height: 50px;
      }
      .searchFriendInModal {
        top: 8px;
        padding-bottom: 5px;
      }
      .empty-msg-mdl .modal-container {
          padding: 20px 10px 10px;
      }
    }




    @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px) 
    and (orientation : landscape) {
        .empty-msg-mdl .modal-body {
            height: 65vh;
            padding: 0px 15px;
        }

        .modal-close>div img {
                width: 10px;
        }

        .modal-close>div {
            margin-top: -10px;
            margin-left: 10px;
        }
        .searchFriendInModal {
            margin: 0px 15px;
        }
        .searchFriendInModal input {
            height: 40px;
            padding: 3px 10px;
        }
        .searchFriendInModal img {
            right: 10px;
            top: 13px;
        }
    }
</style>


